// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import moment from 'moment'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, validPhone, createDefaultVehicle, getWalletScriptUrl, createDefaultEmployerDetails } from '../../constants/globalConstants'
import Header from '../../components/global/Header'
import Steps from '../../components/global/Steps'
import Home from '../home'
import SignUp from '../signup'
import Pass from '../pass'
import ThankYou from '../thankyou'
import ThankYouRequest from '../../pages/permitRequest/thankyou'
import { Circles } from 'react-loader-spinner'
import { encryptionHandler, validateEmail, isPermissionExist, sortPortalPermissionByKey, validatePassword, hasDuplicateAnyKeyValues, validatePhone, isVehicleLimitExceeded, getDeviceType, showhideWalletButton, makeEmployerPayload, formatYearMonthExpiry, validatorRule, handleValidator, excludeKeysFromValidator, getPartnerDetails, encodePasswordBase } from '../../utils/helper'
import { updateWaitingList } from '../../redux/actions/waitingListActions'
//import { bookPermit ,getPaymentInitials,saveBookingBeforePayment,saveBookingAfterPayment} from '../../redux/actions/paymentActions'
import { getPaymentInitials, yankeesPurchasePermit, purchasePermit, updatePermit } from '../../redux/actions/paymentActions'

import { checkIfValidUserExists, permitRateList } from '../../redux/actions/BasicInfoAction'
import useOtpVerification from '../../Hooks/useOtpVerification'
import { addEventLog } from '../warningCitation/redux/actions/EventsLog'
import { errorMessage } from '../../constants/errorMessage'
import AutoRenewal from './autoRenewal'
import WalletButtons from '../../components/walletButtons'
import { addScript } from '../warningCitation/utils/addScript'
import SimpleReactValidator from 'simple-react-validator'
//  recaptcha 
import useRecaptcha from '../../Hooks/useRecaptcha'
import useKeyboardAwareForm from '../../Hooks/useKeyboardAwareForm'


function Main(props) {
    // const facilityState = localStorage.getItem('facility') && localStorage.getItem('facility')!='undefined' ? JSON.parse(localStorage.getItem('facility')) : {}
    const { dispatch, isAuthenticated, partnerDetails, notify, permitPurchageClick } = props
    let defaultCountry = partnerDetails?.facilities?.[0]?.country_code ? partnerDetails?.facilities?.[0]?.country_code : 'US'
    // Read permissions on first render so formData defaults (e.g. userAcknowledge) are correct from the start;
    // child components (Home, Pass) spread stale formData copies in async callbacks, which would undo a later sync
    const [accessPermissions, setAccessPermissions] = useState(() => sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'))
    // T&C consent checkbox is pre-checked unless 'Hide T&C Consent' permission is enabled
    const hideTCConsent = isPermissionExist(accessPermissions, 'Hide T&C Consent')
    const defaultFormData = {
        vehicleList: [createDefaultVehicle(defaultCountry, true)],
        userConsent: false,
        permitNegotiate: 0,
        country: defaultCountry,
        userAcknowledge: !hideTCConsent, request_reason: ''
    }
    const [page, setPage] = useState()
    const [active, setActive] = useState('home')
    const [idProof, setIdProof] = useState(EMPTY_OBJECT)
    const [idMultiProof, setMultiIdProof] = useState(EMPTY_ARRAY)
    const [formData, setFormData] = useState(defaultFormData)
    const [vehicleListArray, setVehicleListArray] = useState(EMPTY_ARRAY)
    const [formError, setFormError] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [previousActive, setPreviousActive] = useState(false)
    const [response, setResponse] = useState(EMPTY_OBJECT)
    const [paymentResponse, setPaymentResponse] = useState(false)
    const [paymentStatus, setPaymentStatus] = useState(EMPTY_OBJECT)
    const [VehiclePrev, setVehiclePrev] = useState(true)
    const [vehicleCount, setvehicleCount] = useState(0)
    const [errorMessages, setErrorMessage] = useState()
    const [res, setRes] = useState('')
    const [showTerm, setTermShow] = useState(false)
    // const [url, setUrl] = useState('')
    const [guid, setGuid] = useState(EMPTY_OBJECT)
    const promotion = window.location.toString().split('/')[4]


    const [categoryURL, setCategoryURL] = useState(false)
    const [invalidCredentials, setInvalidCredentialsError] = useState('')
    const [mainVehicleMakeList, setMainVehicleMakeList] = useState(EMPTY_ARRAY)
    const [universityidProof, setUniversityidProof] = useState(EMPTY_OBJECT)
    const [selectedVehicleList, setSelectedVehicleList] = useState(EMPTY_ARRAY)

    const [totalPrice, setTotalPrice] = useState(0)
    const [isIOSDevice, setIsIOSdevice] = useState(false)
    const [verifyPrepay, setVerifyPrepay] = useState('1')
    const [walletDisable, setWalletDisable] = useState(false)

    // ===== Signup OTP (driven by the Next button) — shared hook =====
    const {
        otp, otpSent, otpError, otpLoading, otpSentFor, resendCooldown, resendCount,
        canResend, resendLimitReached, maxOtpResend, handleOtpChange, handleSendOtp,
        handleResendOtp, handleVerifyOtp, resetOtp
    } = useOtpVerification({ process: 'signup' })

    const searchParams = new URLSearchParams(location.search)
    const loaded = useRef()
    const applePaySessionRef = useRef(null)
    const [walletButtonShow, setWalletButtonShow] = useState(null)

    const [documentTypes, setDocumentTypes] = useState(EMPTY_ARRAY)

    const [employerDetails, setEmployerDetails] = useState(createDefaultEmployerDetails(defaultCountry))

    const [isCardFormVisible, setCardFormVisible] = useState(false)

    const validator = useRef(new SimpleReactValidator({
        element: message => <span className="form-text text-danger h-40">{message}</span>,
        validators: validatorRule
    }))
    const [, forceUpdate] = useState()
    // recaptcha 
    const { getToken } = useRecaptcha()


    // EOS-973
    const tokenRef = useRef(null)
    const [cardToken, setCardToken] = useState('')
    const [iframeErrorMsg, setIframeErrorMsg] = useState('')
    // EOS-973


    const handleModalTerm = () => {
        let filteredValidatorFieldKeys = excludeKeysFromValidator(validator, isCardFormVisible, formData, accessPermissions)

        filteredValidatorFieldKeys = isPermissionExist(accessPermissions, 'Hide Address Fields')
            ? filteredValidatorFieldKeys?.filter(
                field => !['address1', 'state', 'city', 'zipcode'].includes(field)
            )
            : filteredValidatorFieldKeys

        // We'll pass in formData as 'data', no prepay or permit amount for this check
        if (!formValidation(formData, null, formData?.permit_final_amount, filteredValidatorFieldKeys)) {
            // If validation fails, do not open the modal
            setTermShow(false)
            return
        }
        setTermShow((prevShowTerm) => !prevShowTerm)
    }

    const getVals = () => {
        return formData
    }

    useEffect(() => {
        const deviceType = getDeviceType()
        setIsIOSdevice(deviceType)
        if (searchParams?.size > 0) {
            setCategoryURL(true)
        }
    }, [])

    useEffect(() => {
        if (searchParams?.get('permitID')) {
            setCardFormVisible(false)
        }
    }, [searchParams?.get('permitID')])

    // Load Wallet Payment Script
    useEffect(() => {
        // Load Wallet Payment Script
        if (formData?.selFaclity && (formData?.selFaclity?.facility_configuration?.show_google_pay_button == '1' || formData?.selFaclity?.facility_configuration?.show_apple_pay_button == '1')) {
            const paymentGateway = formData?.selFaclity?.facility_payment_details?.facility_payment_type_id
            const applePayScript = getWalletScriptUrl(paymentGateway)
            Object.values(applePayScript)?.map((item) => {
                if (item) {
                    addScript(loaded, item, '')
                }
            })
            const getWalletPermission = isPermissionExist(accessPermissions, 'Enable A/G Pay - Permit')
            setWalletButtonShow(showhideWalletButton(formData?.selFaclity) && getWalletPermission)
        }
        // Load Wallet Payment Script
    }, [EMPTY_ARRAY, formData?.selFaclity, accessPermissions])

    //const navigate = useNavigate()
    const formRef = useRef()
    // EOS-5229 keep the focused field (Create Password / Confirm Password sit at
    // the end of the signup step) above the mobile soft keyboard
    useKeyboardAwareForm(formRef)
    useEffect(() => {
        if (page == 'thankyou') {
            setActive('thankyou')
        }
        if (page == 'thankyouRequest') {
            setActive('thankyouRequest')
        }
        if (page == 'pass') {
            paymentInitials(formData)
        }
    }, [page])

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])

    // Permissions load asynchronously, so sync the initial consent state once they are available
    useEffect(() => {
        setFormData((prev) => ({ ...prev, userAcknowledge: !hideTCConsent }))
    }, [hideTCConsent])

    useEffect(() => {
        if (isAuthenticated) {
            setIsLoggedIn(true)
        } else {
            const getuserDatafromLocal = JSON.parse(localStorage.getItem('userData'))
            if (getuserDatafromLocal?.access_token && getuserDatafromLocal?.access_token != '') {
                setIsLoggedIn(true)
            } else {
                setIsLoggedIn(false)
            }
        }


    }, [EMPTY_ARRAY, isAuthenticated, page])

    useEffect(() => {
        setActive('home')
    }, [permitPurchageClick])

    const paymentInitials = (formData) => {
        const facility = localStorage.getItem('facility') ? JSON.parse(localStorage.getItem('facility')) : {}

        const paymentSessionPayload = {
            'permit_rate_id': formData?.permit_rate_id,
            'license_number': formData?.license_number,
            'facility_id': formData?.facility_id ? formData?.facility_id : facility?.id ? facility?.id : '',
            'promocode': '',
            'permit_service': formData?.permitService && formData?.permitService.length > 0 ? formData?.permitService : []
        }
        dispatch(getPaymentInitials(paymentSessionPayload)).then((response) => {
            // setUrl(response?.data?.api_url)
            setRes(response?.data?.ipgSession)
            setGuid(response?.data?.guid)
            localStorage.setItem('paymentSession', JSON.stringify(response?.data))
        }).catch((err) => {
            notify('error', err ? err : 'Something went wrong, Please try again!')
            setIsLoading(false)
        })
    }


    const checkPermitUsage = () => {
        const facility = localStorage.getItem('facility') ? JSON.parse(localStorage.getItem('facility')) : {}

        const permitPayload = {
            'facility_id': formData?.facility_id ? formData?.facility_id : facility?.id ? facility?.id : '',
            'is_promotion': promotion && promotion != '' && promotion == 'permittype2' ? '1' : searchParams?.get('permitID') ? '1' : '0',
            'driving_license': formData?.license_number || '',
            category_id: formData?.permit_category || '',
        }
        if (formData?.selFaclity?.facility_configuration?.permit_upload_docs_enabled == '1') {
            permitPayload.is_permit_type = '1'
        }
        dispatch(permitRateList(permitPayload)).then((res) => {
            const selectedPermit = res?.data?.filter((item) => item?.id == formData?.permit_type)
            // const permit = selectedPermit?.data[0]
            const permitRates = selectedPermit?.[0]?.permit_rate
            const selectedPermitRates = permitRates?.filter((item) => item?.id == formData?.permit_rate_id)
            const facility = localStorage.getItem('facility') ? JSON.parse(localStorage.getItem('facility')) : {}

            const selectedPermitRate = selectedPermitRates?.[0]
            if (selectedPermitRate?.remaining_usage == 0) {
                localStorage.removeItem('paymentSession')
                const userData = JSON.parse(localStorage.getItem('userData'))
                const payload = {
                    facility_id: formData?.facility_id ? formData?.facility_id : facility?.id ? facility?.id : '',
                    partner_id: partnerDetails?.id,
                    name: `${formData?.firstname ? formData?.firstname : ''} ${formData?.lastname ? formData?.lastname : ''}`,
                    email: formData?.email ? formData?.email : '',
                    phone: formData?.phone ? formData?.phone : '',
                    license_number: formData?.license_number ? formData?.license_number : '',
                    first_name: formData?.firstname ? formData?.firstname : '',
                    confirm_password: encodePasswordBase(formData?.cpassword),
                    password: encodePasswordBase(formData?.password),
                    last_name: formData?.lastname ? formData?.lastname : '',
                    user_id: isLoggedIn ? userData?.user?.id : '',
                    address1: formData?.address1 ? formData?.address1 : '',
                    address2: formData?.address2 ? formData?.address2 : '',
                    city: formData?.city ? formData?.city : '',
                    state: formData?.state ? formData?.state : '',
                    zipcode: formData?.zipcode ? formData?.zipcode : '',
                    permit_rate: formData?.permit_rate ? formData?.permit_rate : '',
                    permit_rate_id: formData?.permit_rate_id ? formData?.permit_rate_id : '',
                    desired_start_date: formData?.desired_start_date ? moment(formData?.desired_start_date).format('YYYY/MM/DD') : moment().format('YYYY/MM/DD'),
                    month: 1,
                    type_id: 3
                }
                dispatch(updateWaitingList(payload)).then((res) => {
                    localStorage.removeItem('paymentSession')
                    if (res?.data) {
                        const userData = res?.data?.userDetails
                        if (userData?.access_token && userData?.access_token != '') {
                            localStorage.setItem('userData', JSON.stringify(userData))
                        } else {
                            const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                            if (userDetailsFromLocal) {
                                userDetailsFromLocal.user = userData
                                localStorage.setItem('userData', JSON.stringify(userDetailsFromLocal))
                            }

                        }
                    }
                    setIsLoading(false)
                    setResponse(response)
                    setPaymentStatus(false)
                    setActive('thankyou')
                    setResponse(res?.data?.message ? res?.data?.message : 'Maximum passes have been sold for this permit, You are added in the waiting list, and will be notified when a pass is available.')
                    if (res?.data?.message == 'Invalid password.') {
                        setPreviousActive(true)
                    } else {
                        setPreviousActive(false)
                    }
                }).catch((err) => {
                    localStorage.removeItem('paymentSession')
                    const response = err?.errors
                    setResponse(response?.message ? response?.message : 'Something went wrong, Please try again!')
                    if (response?.message == 'Invalid password.') {
                        setPreviousActive(true)
                    } else {
                        setPreviousActive(false)
                    }
                    setIsLoading(false)
                    setResponse(response)
                    setPaymentStatus(false)
                    setActive('thankyou')
                })
            } else {
                setIsLoading(false)
                setErrorMessage('')
                setActive('pass')
            }
        }).catch((err) => {
            localStorage.removeItem('paymentSession')
            const response = err?.errors
            setResponse(response?.message ? response?.message : 'Something went wrong, Please try again!')
            if (response?.message == 'Invalid password.') {
                setPreviousActive(true)
            } else {
                setPreviousActive(false)
            }
            setIsLoading(false)
            setActive('thankyou')
        })
    }

    // If email/phone changes after an OTP was sent, invalidate the OTP flow.
    // Skip the toast when formData is cleared (e.g. after successful permit purchase).
    useEffect(() => {
        if (!otpSent || !otpSentFor) {
            return
        }
        if (
            (otpSentFor.email || '') === (formData?.email || '') &&
            (otpSentFor.phone || '') === (formData?.phone || '')
        ) {
            return
        }

        // Form reset / purchase success clears email — reset OTP silently, no message.
        if (!formData?.email) {
            resetOtp()
            return
        }

        const wasVerified = formData?.otpVerified
        resetOtp()
        if (wasVerified) {
            setFormData({ ...formData, otpVerified: false })
        }
        notify('error', wasVerified
            ? 'Your email/phone has changed. Please verify again with a new OTP.'
            : 'Your email/phone has changed. Please request a new OTP.')
    }, [formData?.email, formData?.phone])

    // Send OTP from Next button (clears page-level loader when done)
    const sendSignupOtp = () => {
        const email = formData?.email
        const phone = formData?.phone
        handleSendOtp(email, phone).then((ok) => {
            setIsLoading(false)
            if (ok) {
                notify('success', `A verification OTP has been sent to ${email}.`)
            }
        })
    }

    const handleResendSignupOtp = () => {
        handleResendOtp(formData?.email, formData?.phone)
    }

    // Runs the existing user-validation + permit-usage check that continues the flow
    const runSignupUserValidation = () => {
        const payload = {
            email: formData?.email,
            password: encodePasswordBase(formData?.password),
            partner_id: partnerDetails?.id
        }
        dispatch(checkIfValidUserExists(payload)).then((res) => {
            if (res?.data && res?.data != null) {
                if ((!formData?.phone || (formData?.phone && validPhone.test(formData?.phone) && formData?.phone?.length == 10))) {
                    checkPermitUsage()
                } else {
                    setIsLoading(false)
                }
                setInvalidCredentialsError('')
            } else {
                if (res?.errors?.message == 'User not found') {
                    if ((!formData?.phone || (formData?.phone && validPhone.test(formData?.phone) && formData?.phone?.length == 10))) {
                        checkPermitUsage()
                    } else {
                        setIsLoading(false)
                    }
                    setInvalidCredentialsError('')
                } else {
                    setIsLoading(false)
                    setInvalidCredentialsError(res?.errors?.message ? res?.errors?.message : errorMessage?.invalidCredentials)
                    dispatch(addEventLog(res, 'USER VALIDATION CHECK FAILS'))
                }
            }
        }).catch((err) => {
            if (err?.errors?.message == 'User not found') {
                if ((!formData?.phone || (formData?.phone && validPhone.test(formData?.phone) && formData?.phone?.length == 10))) {
                    checkPermitUsage()
                } else {
                    setIsLoading(false)
                }
                setInvalidCredentialsError('')
            } else {
                setIsLoading(false)
                setInvalidCredentialsError(err?.message ? err?.message : errorMessage?.invalidCredentials)
                dispatch(addEventLog(err, 'USER VALIDATION CHECK FAILS'))
            }
        })
    }

    // Verify the entered OTP and, on success, continue the signup flow
    const verifySignupOtpAndProceed = () => {
        handleVerifyOtp(formData?.email, formData?.phone).then((ok) => {
            if (ok) {
                setFormData({ ...formData, otpVerified: true })
                runSignupUserValidation()
            } else {
                setIsLoading(false)
            }
        })
    }

    const handleNext = () => {
        // const licenseCheck = !isPermissionExist(accessPermissions, 'Driving License')
        if (page == 'home') {
            setFormError('home')
            setErrorMessage('')
            // let validationCheck = false
            // if (isPermissionExist(accessPermissions, 'Permit Category') && Object.values(formData).length > 0 && formData?.facility_id && (formData?.is_hide_vehicle || vehicleListArray?.length > 0) && formData?.permit_rate != '' && formData?.permit_category && formData?.permit_category != '') {
            //     validationCheck = true

            // } else if (!isPermissionExist(accessPermissions, 'Permit Category') && Object.values(formData).length > 0 && formData?.facility_id && (formData?.is_hide_vehicle || vehicleListArray?.length > 0) && formData?.permit_rate != '') {
            //     validationCheck = true

            // } else {
            //     validationCheck = false
            // }
            // if (validationCheck) {
            const maxAllowed = partnerDetails?.max_vehicle
            const limitExceeded = isVehicleLimitExceeded(accessPermissions, selectedVehicleList?.length, maxAllowed, false)
            let employerPermission = (isPermissionExist(accessPermissions, 'Display Employer Details') &&
                formData?.selFaclity?.facility_configuration?.permit_employer_name_enabled == '1' &&
                formData?.selectedPermitType?.[0]?.permit_rate?.[0]?.is_employer == '1')

            let validFields = ['employer_name', 'employer_phone']
            let isValid = handleValidator(validator, employerPermission ? validFields : [], forceUpdate)

            if (isValid) {
                if ((isPermissionExist(accessPermissions, 'Permit Category') && (formData?.is_display_reason ? formData?.request_reason != '' && formData?.request_reason?.length >= 30 && formData?.request_reason?.length <= 200 : true) && formData?.permit_category && formData?.permit_category != '' && (formData?.is_hide_vehicle || (selectedVehicleList?.length > 0 && !limitExceeded)))
                    || (!isPermissionExist(accessPermissions, 'Permit Category')) && Object.values(formData).length > 0 && formData?.facility_id && (formData?.is_hide_vehicle || (selectedVehicleList?.length > 0 && !limitExceeded)) && formData?.permit_rate != '' && idMultiProof?.length == documentTypes?.length) {
                    // if (Object.values(formData).length > 0 && formData?.facility_id && vehicleListArray?.length  > 0 && formData?.permit_rate != '') {
                    // if (licenseCheck && (formData?.license_number.length < 7 || formData?.license_number.length > 13 || !validLicenceNumber.test(formData?.license_number))) {
                    //     setErrorMessage('')
                    // } else 
                    if ((!formData?.is_hide_staff && (formData?.user_type_id == '' || formData?.user_type_id == null || formData?.user_type_id == undefined || formData?.user_type_id?.length != 7)) || formData?.permit_rate == '' || formData?.permit_rate == undefined || formData?.permit_rate == null) {
                        setErrorMessage('')
                    } else if (formData?.selectedPermitType?.[0]?.is_hide_upload_id == '0' && Object.keys(universityidProof).length == 0) {
                        // setErrorMessage('')
                        setFormError('home')
                    } else {
                        let newlyAddedVehicle = selectedVehicleList?.filter(item => !item?.id)
                        let totalVehiclesList = [...newlyAddedVehicle, ...vehicleListArray]
                        const emptyLicenseVehicle = totalVehiclesList?.filter((item) => item?.license_plate == '' || item?.license_plate.length < 2)
                        if (formData?.is_hide_vehicle) {
                            setErrorMessage('')
                            setActive('signup')
                            setVehiclePrev(false)
                        } else {
                            const emptyVehicleType = totalVehiclesList?.filter((item) => item?.vehicle_type == '')
                            if (emptyLicenseVehicle?.length > 0) {
                                const LicensePlates = emptyLicenseVehicle?.map((item) => item?.license_plate)?.toString()
                                notify('error', `Any of your Vehicle is either having an empty license plate, or the license plate is not valid Please remove/update the vehicle from the account to proceed. Plates: "${LicensePlates}"`)
                                // setErrorMessage('Please add a vehicle')
                            } else if ((isPermissionExist(accessPermissions, 'Get Vehicle Type') && emptyVehicleType.length > 0)) {
                                // setErrorMessage('Please add a vehicle type')
                            } else {
                                let newPyalod = []
                                let checkMakeModel = false
                                let licenseDuplicateCheck = hasDuplicateAnyKeyValues(totalVehiclesList, ['license_plate'])
                                selectedVehicleList.map((item) => {
                                    // if(isRoc){
                                    const make = item?.make_id ? '' : (item?.othermake ? (item?.maketext || '') : (item?.make || ''))
                                    const model = item?.model_id ? '' : (item?.othermodel ? (item?.modeltext || '') : (item?.model || ''))
                                    newPyalod.push({ 'license_plate': item?.license_plate, 'make': make, 'make_id': item?.make_id ? item?.make_id : '', 'model': model, 'model_id': item?.model_id ? item?.model_id : '', 'color': item?.color_id ? '' : item?.color, 'color_id': item?.color_id ? item?.color_id : '', 'country': item?.country ? item.country : '', 'state_id': item?.state_id, 'vehicle_number': item?.vehicle_number, 'vehicle_type': item?.vehicle_type, 'vehicle_type_id': item?.vehicle_type_id ?? '' })

                                    //check
                                    if (checkMakeModel == false && item?.make == 'Others') {
                                        checkMakeModel = mainVehicleMakeList?.some((value) => value?.name?.toLowerCase() == item?.maketext?.toLowerCase())
                                        if (checkMakeModel) {
                                            notify('error', `You can not add duplicate ${licenseDuplicateCheck ? 'License Plate and' : ''} Make.`)
                                        }
                                    } else if (checkMakeModel == false && item?.make != 'Others' && item?.model == 'Others') {
                                        let makeList = mainVehicleMakeList?.filter((v) => v.name.toLowerCase() == item?.make.toLowerCase())
                                        checkMakeModel = makeList[0]?.mst_model?.some((value) => value?.name?.toLowerCase() == item?.modeltext?.toLowerCase())
                                        if (checkMakeModel) {
                                            notify('error', `You can not add duplicate ${licenseDuplicateCheck ? 'License Plate and' : ''} Model.`)
                                        }
                                    }
                                })
                                if (!checkMakeModel) {
                                    if (licenseDuplicateCheck) {
                                        notify('error', 'You can not add duplicate License Plate.')
                                    } else {
                                        const payloadData = { ...formData }
                                        payloadData['vehicleList'] = selectedVehicleList
                                        setFormData({ ...payloadData })
                                        setErrorMessage('')
                                        setActive('signup')
                                        setVehiclePrev(false)
                                    }
                                }
                            }
                        }
                    }
                } else {
                    if (selectedVehicleList?.length == 0) {
                        notify('error', 'You have to add at least one vehicle.')
                    } else if (limitExceeded) {
                        notify('error', `You can not add more than ${maxAllowed} vehicles.`)
                    }
                }
            }
        } else if (page == 'signup') {
            // paymentInitials(formData)
            setFormError('signup')
            setIsLoading(true)
            setErrorMessage('')
            let validFields = isPermissionExist(accessPermissions, 'Hide Address Fields') ? ['firstname', 'phone'] : ['firstname', 'phone', 'address1', 'country', 'state', 'city', 'zipcode']

            if (handleValidator(validator, validFields, forceUpdate)) {
                // if (Object.values(formData).length > 0 && formData?.firstname && formData?.email &&  ((isPermissionExist(accessPermissions, 'Permit Phone Mandatory') ? formData?.phone :!formData?.phone) || (formData?.phone && validatePhone(formData?.phone))) && formData?.address1 && formData?.city && formData?.state && formData?.zipcode) {
                if (Object.values(formData).length > 0 && formData?.firstname && formData?.email && ((isPermissionExist(accessPermissions, 'Permit Phone Mandatory') && formData?.selFaclity?.facility_configuration?.permit_phone_required == '1' ? formData?.phone : !formData?.phone) || (formData?.phone && validatePhone(formData?.phone))) && (isPermissionExist(accessPermissions, 'Hide Address Fields') || (formData?.address1 && formData?.city && formData?.state && formData?.zipcode))) {
                    if (isLoggedIn) {
                        if (formData?.email) {
                            if (validateEmail(formData?.email, formData?.selectedCategory, formData?.selectedPermitType?.[0])) {
                                checkPermitUsage()
                                if ((!formData?.phone || (formData?.phone && validatePhone(formData?.phone)))) {
                                    checkPermitUsage()
                                } else {
                                    setIsLoading(false)
                                }
                            } else {
                                setIsLoading(false)
                            }
                        }
                    } else {
                        if (formData?.email) {
                            if (validateEmail(formData?.email, formData?.selectedCategory, formData?.selectedPermitType?.[0])) {
                                setErrorMessage('')
                                if (formData?.password) {
                                    if (formData?.password == formData?.cpassword) {
                                        if (validatePassword(formData?.password)) {
                                            // OTP is driven by the Next button:
                                            // - already verified -> continue signup validation
                                            // - not sent yet -> send OTP and reveal the OTP field ("Verify OTP")
                                            // - sent but not verified -> verify OTP, then continue
                                            if (formData?.otpVerified) {
                                                runSignupUserValidation()
                                            } else if (!otpSent) {
                                                sendSignupOtp()
                                            } else {
                                                verifySignupOtpAndProceed()
                                            }
                                        } else {
                                            setIsLoading(false)
                                        }

                                    } else {
                                        setIsLoading(false)
                                    }
                                } else {
                                    setIsLoading(false)
                                }

                            } else {
                                setIsLoading(false)
                            }
                        }
                    }
                } else {
                    setIsLoading(false)
                }
            } else {
                setIsLoading(false)
            }

        } else if (page == 'pass') {
            paymentInitials(formData)
            setErrorMessage('')
            setActive('thankyou')
        }
    }
    const handlePrevious = () => {
        setVerifyPrepay('1')
        if (page == 'signup') {
            setErrorMessage('')
            setActive('home')
        } else if (page == 'pass') {
            setErrorMessage('')
            setActive('signup')
        } else if (page == 'thankyou') {
            setErrorMessage('')
            setActive('pass')
        }
    }

    const closeApplePaySession = (endsession) => {
        if (applePaySessionRef.current) {
            if (endsession === 'success') {
                applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_SUCCESS)
            } else if (endsession === 'failed') {
                applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_FAILURE)
            } else {
                applePaySessionRef.current.abort()
            }
        }
    }

    const formValidation = (data = null, prepay = null, permit_final_amount, validFields = false) => {
        if (!handleValidator(validator, validFields, forceUpdate) && !data?.paymentMethods && !data?.walletPay) {
            return false
        }

        const hasFormData = Object.values(formData || {}).length > 0

        const isPostPay = prepay === 'post'

        const hasPaymentProfile =
            formData?.payment_profile_id

        const hasTransaction =
            data?.transaction_id ||
            ((data?.paymentMethods || data?.walletPay) && walletButtonShow)

        const hasValidCardDetails =
            formData?.card_pan &&
            (formData?.name &&
                formData?.expiration_date &&
                formData?.expiration_date.length > 3 &&
                formData?.expiration_date.length < 6 &&
                formData?.card_card_security_cvx_2) || (cardToken && cardToken?.token)

        const isZeroAmount = Number(permit_final_amount) === 0

        const paymentCondition =
            hasFormData &&
            (isPostPay || hasPaymentProfile || hasTransaction || hasValidCardDetails)
        const termsPermission =
            !isPermissionExist(accessPermissions, 'Display Terms & Conditions') ||
            (
                isPermissionExist(accessPermissions, 'Display Terms & Conditions') &&
                formData?.userAcknowledge
            )

        const tcAcceptanceCondition =
            !isPermissionExist(accessPermissions, 'Display TC Acceptance') ||
            (
                isPermissionExist(accessPermissions, 'Display TC Acceptance') &&
                formData?.tc_acceptance_signature
            )

        if (!termsPermission || !paymentCondition) {
            setFormError('pass')
        }

        const finalCondition =
            (paymentCondition || isZeroAmount) &&
            (isPostPay || (termsPermission && tcAcceptanceCondition))


        return finalCondition
    }

    const handleSubmit = async (data = null, prepay = null, terms_condition_error = false, validFields = []) => {
        if (data) {
            setFormData(data)
        }
        const desiredStartDate = props?.data?.proRateList?.data?.start_date || (formData?.desired_start_date ? moment(formData.desired_start_date).format('YYYY/MM/DD') : null) || moment().format('YYYY/MM/DD')
        let permit_final_amount = formData?.permit_final_amount ? Number(formData?.permit_final_amount.replace(',', '')) : ''
        // if (formData?.permitServicePrice) {
        //     permit_final_amount = Number(formData?.permit_rate) + Number(formData?.permitServicePrice)
        // }
        // permit_final_amount = Number(permit_final_amount).toFixed(2)
        // const event = e
        // const form = formRef.current
        if (prepay != 'post') {
            setFormError('pass')
        }
        // paymentInitials(formData)
        // if (Object.values(formData).length > 0 && ((formData?.card_pan && formData?.name && formData?.card_date_expiry_year && formData?.card_card_security_cvx_2 && formData?.zip_code))) {
        if (!isLoading) {
            // if (Object.values(formData).length > 0 && (formData?.payment_profile_id || (formData?.card_pan && formData?.name && formData?.card_date_expiry_month && formData?.card_date_expiry_year && formData?.card_card_security_cvx_2 && formData?.zip_code)) || formData?.permit_rate == '0.00') {
            // if (Object.values(formData).length > 0  && (!isPermissionExist(accessPermissions, 'Display Terms & Conditions') || (isPermissionExist(accessPermissions, 'Display Terms & Conditions') && formData?.userAcknowledge)) &&  (formData?.payment_profile_id || (formData?.card_pan && formData?.name && formData?.expiration_date && (formData?.expiration_date?.length>3 && formData?.expiration_date?.length<6) && formData?.card_card_security_cvx_2 && formData?.zip_code))
            //  || (permit_final_amount == '0.00')) {

            // if ((Object.values(formData).length > 0 && (prepay == 'post' || formData?.payment_profile_id || (data?.transaction_id || ((data?.paymentMethods || data?.walletPay) && walletButtonShow)) ||  (formData?.card_pan && formData?.name && formData?.expiration_date && (formData?.expiration_date?.length > 3 && formData?.expiration_date?.length < 6) && formData?.card_card_security_cvx_2))
            //     || (permit_final_amount == '0.00')) && (!isPermissionExist(accessPermissions, 'Display Terms & Conditions') || (isPermissionExist(accessPermissions, 'Display Terms & Conditions') && formData?.userAcknowledge))) {

            // if ((Object.values(formData).length > 0 && (prepay == 'post' || formData?.payment_profile_id || (data?.transaction_id || ((data?.paymentMethods || data?.walletPay) && walletButtonShow)) || (formData?.card_pan && formData?.name && formData?.expiration_date && (formData?.expiration_date?.length > 3 && formData?.expiration_date?.length < 6) && formData?.card_card_security_cvx_2))
            //     || (permit_final_amount == '0.00')) && (!isPermissionExist(accessPermissions, 'Display Terms & Conditions') || (isPermissionExist(accessPermissions, 'Display Terms & Conditions') && formData?.userAcknowledge)) && (prepay == 'post' || isPermissionExist(accessPermissions, 'Display Terms & Conditions') && isPermissionExist(accessPermissions, 'Display TC Acceptance') && formData?.userAcknowledge && formData?.tc_acceptance_signature)) {

            let filteredValidatorFieldKeys = validFields && validFields?.length > 0 ? validFields : excludeKeysFromValidator(validator, isCardFormVisible, formData, accessPermissions)
            filteredValidatorFieldKeys = isPermissionExist(accessPermissions, 'Hide Address Fields')
                ? filteredValidatorFieldKeys?.filter(
                    field => !['address1', 'state', 'city', 'zipcode'].includes(field)
                )
                : filteredValidatorFieldKeys
            if (formValidation(data, prepay, permit_final_amount, filteredValidatorFieldKeys)) {

                setErrorMessage('')
                setIsLoading(true)

                // ===== reCAPTCHA v3: Generate Token for Permit Purchase =====
                const captchaToken = await getToken('permit_purchase')
                if (!captchaToken) {
                    notify('error', 'Security verification failed. Please try again.')
                    setIsLoading(false)
                    return
                }
                // ===== End reCAPTCHA =====

                const userData = JSON.parse(localStorage.getItem('userData'))
                const paymentSessionValue = JSON.parse(localStorage.getItem('paymentSession'))
                let nonce
                // if (!formData?.payment_profile_id && (formData?.payment_profile_id == '' || formData?.payment_profile_id == undefined || formData?.payment_profile_id == null)
                //     && (formData?.name && formData?.card_pan && formData?.card_date_expiry_month && formData?.card_date_expiry_year && formData?.card_card_security_cvx_2 && formData?.zip_code)
                // ) {
                if (!formData?.payment_profile_id && (formData?.payment_profile_id == '' || formData?.payment_profile_id == undefined || formData?.payment_profile_id == null)
                    && (formData?.name && formData?.card_pan && formData?.expiration_date && formData?.card_card_security_cvx_2) || (cardToken && cardToken?.token)
                ) {
                    // if (formData?.card_date_expiry_year < moment(new Date()).format('YY') || (formData?.card_date_expiry_year == moment(new Date()).format('YY') && formData?.card_date_expiry_month < moment(new Date()).format('MM'))) {
                    //     notify('error', 'Please Enter a valid card expire date')
                    //     setIsLoading(false)
                    //     return
                    // }
                    // const card_expiration_date = formData?.card_date_expiry_month + formData?.card_date_expiry_year
                    if (formData?.selFaclity?.facility_payment_details?.facility_payment_type_id == '3' && cardToken && cardToken.token) {
                        // For Fiserv, use cardToken to create payment data
                        let card = {
                            name_on_card: data?.name_on_card || '',
                            card_number: cardToken?.token || '',
                            expiration_date: formatYearMonthExpiry(cardToken?.expiry),
                            security_code: '',
                        }
                        if (cardToken?.zip_code) {
                            card.zip_code = cardToken?.zip_code
                        }
                        nonce = encryptionHandler(card)

                    } else {

                        const card_expiration_date = formData?.expiration_date

                        let cardData = {
                            name_on_card: formData?.name,
                            card_number: formData?.card_pan ? formData?.card_pan.replace(/\D/g, '') : '',
                            expiration_date: card_expiration_date ? card_expiration_date.replace(/\D/g, '') : '',
                            security_code: formData?.card_card_security_cvx_2
                        }
                        if (formData?.zip_code) {
                            cardData.zip_code = formData?.zip_code
                        }
                        nonce = encryptionHandler(cardData)
                    }
                }

                // let permit_final_amount = Number(formData?.permit_rate)
                // if (formData?.permitServicePrice) {
                //     permit_final_amount = Number(formData?.permit_rate) + Number(formData?.permitServicePrice)
                // }
                // permit_final_amount = Number(permit_final_amount).toFixed(2)

                let finalVehicleList = []
                selectedVehicleList?.map((value) => {
                    if (value?.license_plate) {
                        finalVehicleList.push({ 'license_plate': value?.license_plate, 'make': value?.make_id ? '' : (value?.othermake ? value?.maketext : value?.make), 'make_id': value?.make_id ? value?.make_id : '', 'model': value?.model_id ? '' : (value?.othermodel ? value?.modeltext : value?.model), 'model_id': value?.model_id ? value?.model_id : '', 'color': value?.color, 'color_id': value?.color_id ? value?.color_id : '', 'style': value?.style, 'style_id': value?.style_id ? value?.style_id : '', 'state_id': value?.state_id, 'state_name': '', 'country': value?.country ? value?.country : '', 'vehicle_type': value?.vehicle_type, 'vehicle_type_id': value?.vehicle_type_id ?? '' })
                    }
                })

                let Negotiatepayment = formData?.permitNegotiate
                // let Negotiatepayment=formData?.selFaclity?.is_permit_purchase_enabled ? formData?.selFaclity?.is_permit_purchase_enabled=='1' ? '0' :'1' :formData?.permitNegotiate
                if (formData?.permitService?.length > 0) {
                    let checkNegotiatepayment = formData?.permitService?.filter((v) => v?.is_purchase == '0')
                    if (checkNegotiatepayment?.length > 0) {
                        Negotiatepayment = '1'
                    }
                }

                // check permit purchage or request
                const facilityFromStorage = localStorage.getItem('facility') ? JSON.parse(localStorage.getItem('facility')) : {}
                let isPermitPurchase = formData?.selFaclity?.is_permit_purchase_enabled ? formData?.selFaclity?.is_permit_purchase_enabled : facilityFromStorage?.is_permit_purchase_enabled ? facilityFromStorage?.is_permit_purchase_enabled : ''

                if (formData?.selectedPermitType && formData?.selectedPermitType?.length > 0) {
                    let checkNegotiate = formData?.selectedPermitType?.filter((v) => v?.is_purchase == '0')
                    if (checkNegotiate?.length > 0) {
                        isPermitPurchase = '0'
                    }
                }
                if (formData?.permitService && formData?.permitService?.length > 0) {
                    let checkNegotiate = formData?.permitService?.filter((v) => v?.is_purchase == '0')
                    if (checkNegotiate?.length > 0) {
                        isPermitPurchase = '0'
                    }
                }
                const facility = localStorage.getItem('facility') ? JSON.parse(localStorage.getItem('facility')) : {}

                const urlParams = window.location.toString().split('/')
                let formPostData = new FormData()    //formdata object
                formPostData.append('license_number', formData?.license_number ? formData?.license_number : '')   //append the values with key, value pair
                formPostData.append('first_name', formData?.firstname ? formData?.firstname : '')
                formPostData.append('email', formData?.email ? formData?.email : '')
                formPostData.append('phone', formData?.phone ? formData?.phone : '')
                formPostData.append('vehicleList', JSON.stringify(finalVehicleList))
                formPostData.append('confirm_password', formData?.cpassword ? encodePasswordBase(formData?.cpassword) : '')
                formPostData.append('password', formData?.password ? encodePasswordBase(formData?.password) : '')
                formPostData.append('facility_id', formData?.facility_id ? formData?.facility_id : facility?.id ? facility?.id : '')
                formPostData.append('last_name', isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? '' : formData?.lastname ? formData?.lastname : '')
                formPostData.append('user_id', searchParams?.get('permitID') ? formData?.user_id : isLoggedIn ? userData?.user?.id : formData?.user_id || '')
                formPostData.append('address1', formData?.address1 ? formData?.address1 : '')
                formPostData.append('address2', formData?.address2 ? formData?.address2 : '')
                formPostData.append('city', formData?.city ? formData?.city : '')
                formPostData.append('state', formData?.state ? formData?.state : '')
                formPostData.append('country', formData?.country ? formData?.country : '')
                formPostData.append('zipcode', formData?.zipcode ? formData?.zipcode : '')
                formPostData.append('name', formData?.name ? formData?.name : (cardToken?.name_on_card ? cardToken?.name_on_card : ''))
                formPostData.append('permit_rate', formData?.permit_rate ? formData?.permit_rate : '')
                formPostData.append('permit_rate_id', formData?.permit_rate_id ? formData?.permit_rate_id : '')
                formPostData.append('desired_start_date', desiredStartDate)
                formPostData.append('month', 1)
                formPostData.append('user_consent', formData?.userConsent ? formData?.userConsent == true ? 1 : 0 : 0)
                formPostData.append('image_front', idProof?.front ? idProof?.front : '')
                formPostData.append('is_card_req', 1)
                formPostData.append('image_back', idProof?.back ? idProof?.back : '')
                formPostData.append('type_id', 3)
                formPostData.append('booking_label_id', partnerDetails?.id ? partnerDetails?.id : '')
                if (!data?.paymentMethods) {
                    if (nonce) {
                        formPostData.append('nonce', nonce ? nonce : '')
                    } else if (data?.paymentToken && !searchParams?.get('permitID')) {
                        formPostData.append('paymentToken', JSON.stringify(data?.paymentToken))
                    } else if (cardToken && cardToken?.tsepToken) {
                        formPostData.append('paymentToken', JSON.stringify(cardToken))
                        formPostData.append('tsepToken', cardToken?.tsepToken)
                        formPostData.append('transactionID', cardToken?.transactionID || '')
                    } else {
                        console.log('[handleSubmit] Payment: no payment token found', { nonce, dataPaymentToken: data?.paymentToken, cardToken })
                    }
                }
                if (!data?.paymentMethods) {
                    formPostData.append('payment_profile_id', formData?.payment_profile_id ? formData?.payment_profile_id : '')
                }
                if (isPermissionExist(accessPermissions, 'Display Terms & Conditions') && isPermissionExist(accessPermissions, 'Display TC Acceptance') && formData?.userAcknowledge) {
                    const tc_acceptance_date = formData?.tc_acceptance_date ? moment(formData?.tc_acceptance_date).format('YYYY/MM/DD') : moment().format('YYYY/MM/DD')
                    formPostData.append('tc_acceptance_signature', formData?.tc_acceptance_signature ? formData?.tc_acceptance_signature : '')
                    formPostData.append('tc_acceptance_date', tc_acceptance_date ? tc_acceptance_date : '')

                }
                formPostData.append('promocode', formData?.coupon_applied == true ? formData?.promocode ? formData?.promocode : '' : '')
                formPostData.append('reference', paymentSessionValue?.reference ? paymentSessionValue.reference : '')
                formPostData.append('is_admin', 0)
                formPostData.append('permit_type_name', formData?.permit_type_name ? formData?.permit_type_name : '')
                formPostData.append('partner_slug', urlParams[3])
                formPostData.append('permit_final_amount', permit_final_amount)
                formPostData.append('discount_amount', formData?.discount_amount ? formData?.discount_amount : '')
                formPostData.append('processing_fee', formData?.processing_fee ? formData?.processing_fee : '')
                formPostData.append('is_negotiable', formData?.selectedPermitType?.[0]?.is_negotiable ? formData?.selectedPermitType?.[0]?.is_negotiable : '')
                formPostData.append('request_reason', formData?.request_reason ? formData?.request_reason : '')
                formPostData.append('employer_name', formData?.employer_name ? formData?.employer_name : '')
                if ((data?.paymentMethods) && data?.walletPay && walletButtonShow) {
                    formPostData.append('paymentMethods', data?.paymentMethods ? data?.paymentMethods : '')
                    // formPostData.append('paymentMethod', data?.paymentMethods ? data?.paymentMethods : '')
                    formPostData.append('transaction_id', data?.transaction_id ? data?.transaction_id : '')
                    if (isIOSDevice) {
                        formPostData.append('walletPay', JSON.stringify(data?.walletPay)) //Issue in mac only
                    } else {
                        formPostData.append('walletPay', data?.walletPay)
                    }
                }
                formPostData.append('university_id', universityidProof?.uploadFile ? universityidProof?.uploadFile : '')
                formPostData.append('anon', '0')//

                if (formData?.net_parking_amount) {
                    formPostData.append('net_parking_amount', formData?.net_parking_amount)
                }
                if (formData?.surcharge_fee) {
                    formPostData.append('surcharge_fee', formData?.surcharge_fee)
                }
                if (formData?.tax_fee) {
                    formPostData.append('tax_fee', formData?.tax_fee)
                }
                if (formData?.additional_fee) {
                    formPostData.append('additional_fee', formData?.additional_fee)
                }

                let employerPermission = (isPermissionExist(accessPermissions, 'Display Employer Details') &&
                    formData?.selFaclity?.facility_configuration?.permit_employer_name_enabled == '1' &&
                    formData?.selectedPermitType?.[0]?.permit_rate?.[0]?.is_employer == '1')
                if (employerPermission) {
                    const employerPayload = makeEmployerPayload(employerDetails)
                    formPostData.append('employer', JSON.stringify(employerPayload) || {})
                }

                if ((data?.paymentMethods) && data?.walletPay && walletButtonShow) {
                    formPostData.append('paymentMethods', data?.paymentMethods ? data?.paymentMethods : '')
                    // formPostData.append('paymentMethod', data?.paymentMethods ? data?.paymentMethods : '')
                    formPostData.append('transaction_id', data?.transaction_id ? data?.transaction_id : '')
                    if (isIOSDevice) {
                        formPostData.append('walletPay', JSON.stringify(data?.walletPay)) //Issue in mac only
                    } else {
                        formPostData.append('walletPay', data?.walletPay)
                    }
                }
                formPostData.append('university_id', universityidProof?.uploadFile ? universityidProof?.uploadFile : '')
                formPostData.append('anon', '0')//

                if (formData?.net_parking_amount) {
                    formPostData.append('net_parking_amount', formData?.net_parking_amount)
                }
                if (formData?.surcharge_fee) {
                    formPostData.append('surcharge_fee', formData?.surcharge_fee)
                }
                if (formData?.tax_fee) {
                    formPostData.append('tax_fee', formData?.tax_fee)
                }
                if (formData?.additional_fee) {
                    formPostData.append('additional_fee', formData?.additional_fee)
                }

                if (formData?.permit_rate == '0.00' || Number(formData?.permit_rate) == 0) {
                    formPostData.append('is_booking_direct', 1)
                }
                if (formData?.permitService) {
                    formPostData.append('permitService', JSON.stringify(formData?.permitService))
                }
                if (formData?.permit_category) {
                    formPostData.append('permit_category', formData?.permit_category)

                }
                if (formData?.user_type_id) {
                    formPostData.append('user_type_id', formData?.user_type_id)
                }
                if (formData?.proRateAPIData?.show_auto_consent == '1') {
                    formPostData.append('show_auto_consent', formData?.proRateAPIData?.show_auto_consent)
                }
                if (formData?.proRateAPIData?.hide_auto_consent == '1') {
                    formPostData.append('hide_auto_consent', formData?.proRateAPIData?.hide_auto_consent)
                }

                formPostData.append('permitNegotiate', Negotiatepayment)
                formPostData.append('isPermitPurchase', isPermitPurchase)
                formPostData.append('bookingType', 'Permit')
                formPostData.append('recaptcha_token', captchaToken)

                if (walletButtonShow) {
                    formPostData.append('verify_prepay', (prepay && prepay == 'post') ? '1' : '0')
                }

                localStorage.setItem('bookingType', 'Permit')

                if (isLoggedIn) {
                    formPostData.append('card_last_four', formData?.card_last_four ? formData?.card_last_four : '')
                    formPostData.append('expiry', formData?.expiry ? formData?.expiry : '')
                }
                if (idMultiProof?.length > 0) {
                    idMultiProof?.map((item) => {
                        formPostData.append(item?.type, item?.file)
                    })
                }
                if (formData?.reserved_space_number) {
                    formPostData.append('reserved_space_number', 'R-' + formData?.reserved_space_number)
                }
                let prorateResponse = formData?.proRateAPIData
                if (prorateResponse?.is_keycard_applicable == 1) {
                    formPostData.append('is_keycard_applicable', prorateResponse?.is_keycard_applicable)
                    formPostData.append('keycard_id', prorateResponse?.keycard?.id)
                }

                const obj = {}
                formPostData.forEach((value, key) => {
                    obj[key] = value
                })

                // dispatch(saveBookingBeforePayment(beforePaymentPayload)).then((response) => {
                if (searchParams?.get('permitID')) {
                    formPostData.append('id', searchParams?.get('permitID'))
                    formPostData.append('partner_id', getPartnerDetails()?.id)
                    formPostData.append('is_migrate', 1)

                    dispatch(updatePermit(formPostData)).then((response) => {
                        // APILoad.current = true
                        if (prepay && prepay == 'post' && response?.data) {
                            setVerifyPrepay('0')
                            setIsLoading(false)
                        } else {
                            const responseData = response?.data
                            setTermShow(false)

                            // localStorage.setItem('responseData-before-api', JSON.stringify(responseData))               
                            if (responseData) {
                                setIsLoading(false)
                                setPaymentResponse(responseData)
                                setPaymentStatus(true)
                                setPreviousActive(false)
                                setFormData(defaultFormData)
                                setDocumentTypes(EMPTY_ARRAY)
                                closeApplePaySession('success')
                                const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                                if (userDetailsFromLocal?.access_token) {
                                    if (responseData?.error_msg && responseData?.error_msg != '') {

                                        setResponse(responseData?.error_msg)
                                        setPaymentStatus(false)
                                        const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                                        userDetailsFromLocal.user = responseData?.userDetails
                                        // const userData = responseData?.userDetails
                                        if (userDetailsFromLocal) {
                                            localStorage.setItem('userData', JSON.stringify(userDetailsFromLocal))
                                        } else {
                                            localStorage.setItem('userData', '{}')
                                        }
                                        dispatch(addEventLog(response, 'PERMIT BOOKING ERROR'))
                                        setPage('thankyou')

                                    } else {

                                        const userData = responseData?.userDetails
                                        if (userData) {
                                            const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                                            userDetailsFromLocal.user = userData
                                            localStorage.setItem('userData', JSON.stringify(userDetailsFromLocal))
                                        } else {
                                            localStorage.setItem('userData', '{}')
                                        }
                                        setResponse(response)
                                        dispatch(addEventLog(response, 'PERMIT BOOKING ERROR'))
                                        setPage('thankyou')
                                    }
                                } else {
                                    if (responseData?.error_msg && responseData?.error_msg != '') {
                                        setResponse(responseData?.error_msg)
                                        setPaymentStatus(false)
                                        const userData = responseData?.userDetails
                                        if (userData) {
                                            localStorage.setItem('userData', JSON.stringify(userData))
                                        } else {
                                            localStorage.setItem('userData', '{}')
                                        }
                                        dispatch(addEventLog(response, 'PERMIT BOOKING ERROR'))

                                        setPage('thankyou')
                                    } else {

                                        const userData = responseData?.userDetails

                                        if (userData) {

                                            localStorage.setItem('userData', JSON.stringify(userData))

                                        } else {
                                            localStorage.setItem('userData', '{}')
                                        }
                                        setPage('thankyou')
                                        dispatch(addEventLog(response, 'PERMIT BOOKING ERROR'))

                                        setResponse(response)
                                    }
                                }

                            } else {
                                setIsLoading(false)
                                closeApplePaySession('failed')
                                const errors = response?.errors
                                setResponse(errors ? errors?.message : 'Something went wrong, Please try again!')
                                //old                  
                                if (errors?.message == 'Invalid password.' || !response?.message || response?.message == '' || response?.message == undefined || response?.message == null) {
                                    setPreviousActive(true)
                                } else {
                                    setPreviousActive(false)
                                }
                                setPaymentStatus(false)
                                dispatch(addEventLog(response, 'PERMIT BOOKING ERROR'))

                                setPage('thankyou')
                            }
                            // formRef.current = false
                        }
                    }).catch((err) => {
                        // APILoad.current = true
                        closeApplePaySession('failed')
                        dispatch(addEventLog(err, 'PERMIT BOOKING ERROR'))
                        setResponse(err ? err : 'Something went wrong, Please try again!')
                        //old                  
                        setIsLoading(false)
                        setPage('thankyou')
                    })
                }
                else if (isPermitPurchase == '0') {

                    formPostData.append('is_payment_authrize', permit_final_amount > 0 ? '1' : '0')
                    if (formData?.permitService?.length > 0) {
                        let checkIs_variable_pay = formData?.permitService?.length > 0 ? formData?.permitService?.filter((v) => v.is_negotiable == '1') : []
                        formPostData.append('is_negotiable', checkIs_variable_pay?.length > 0 ? '1' : '0')
                    }
                    dispatch(yankeesPurchasePermit(formPostData)).then((response) => {
                        if (prepay && prepay == 'post' && response?.data) {
                            setVerifyPrepay('0')
                            setIsLoading(false)
                        } else {
                            setTermShow(false)
                            const responseData = response?.data
                            // localStorage.setItem('responseData-before-api', JSON.stringify(responseData))               
                            if (responseData) {
                                setIsLoading(false)
                                setPaymentResponse(responseData)
                                setPaymentStatus(true)
                                setPreviousActive(false)
                                setFormData(defaultFormData)
                                setDocumentTypes(EMPTY_ARRAY)
                                const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                                closeApplePaySession('success')
                                if (userDetailsFromLocal?.access_token) {
                                    if (responseData?.error_msg && responseData?.error_msg != '') {
                                        setResponse(responseData?.error_msg)
                                        setPaymentStatus(false)
                                        const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                                        userDetailsFromLocal.user = responseData?.userDetails
                                        // const userData = responseData?.userDetails
                                        if (userDetailsFromLocal) {
                                            localStorage.setItem('userData', JSON.stringify(userDetailsFromLocal))
                                        } else {
                                            localStorage.setItem('userData', '{}')
                                        }
                                        setPage('thankyouRequest')

                                    } else {
                                        const userData = responseData?.userDetails
                                        if (userData) {
                                            const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                                            userDetailsFromLocal.user = userData
                                            localStorage.setItem('userData', JSON.stringify(userDetailsFromLocal))
                                        } else {
                                            localStorage.setItem('userData', '{}')
                                        }
                                        setResponse(response)
                                        setPage('thankyouRequest')
                                    }
                                } else {
                                    if (responseData?.error_msg && responseData?.error_msg != '') {
                                        setResponse(responseData?.error_msg)
                                        setPaymentStatus(false)
                                        const userData = responseData?.userDetails
                                        if (userData) {
                                            localStorage.setItem('userData', JSON.stringify(userData))
                                        } else {
                                            localStorage.setItem('userData', '{}')
                                        }
                                        setPage('thankyouRequest')
                                    } else {

                                        const userData = responseData?.userDetails

                                        if (userData) {

                                            localStorage.setItem('userData', JSON.stringify(userData))

                                        } else {
                                            localStorage.setItem('userData', '{}')
                                        }
                                        setPage('thankyouRequest')
                                        setResponse(response)
                                    }
                                }

                            } else {
                                closeApplePaySession('failed')
                                setIsLoading(false)

                                const errors = response?.errors
                                setResponse(errors ? errors?.message : 'Something went wrong, Please try again!')
                                //old                  
                                if (errors?.message == 'Invalid password.' || !response?.message || response?.message == '' || response?.message == undefined || response?.message == null) {
                                    setPreviousActive(true)
                                } else {
                                    setPreviousActive(false)
                                }
                                setIsLoading(false)
                                setPaymentStatus(false)
                                dispatch(addEventLog(response, 'PERMIT BOOKING ERROR'))
                                setPage('thankyou')
                            }
                            // formRef.current = false
                        }
                    }).catch((err) => {
                        closeApplePaySession('failed')
                        setResponse(err ? err : 'Something went wrong, Please try again!')
                        dispatch(addEventLog(err, 'PERMIT BOOKING ERROR'))
                        //old                  
                        setIsLoading(false)
                        setPage('thankyou')
                    })
                } else if (isPermitPurchase == '1') {
                    dispatch(purchasePermit(formPostData)).then((response) => {
                        if (prepay && prepay == 'post' && response?.data) {
                            setVerifyPrepay('0')
                            setIsLoading(false)
                        } else {
                            const responseData = response?.data
                            setTermShow(false)

                            // localStorage.setItem('responseData-before-api', JSON.stringify(responseData))               
                            if (responseData) {
                                setIsLoading(false)
                                setPaymentResponse(responseData)
                                setPaymentStatus(true)
                                setPreviousActive(false)
                                setFormData(defaultFormData)
                                setDocumentTypes(EMPTY_ARRAY)
                                closeApplePaySession('success')
                                const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                                if (userDetailsFromLocal?.access_token) {
                                    if (responseData?.error_msg && responseData?.error_msg != '') {

                                        setResponse(responseData?.error_msg)
                                        setPaymentStatus(false)
                                        const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                                        userDetailsFromLocal.user = responseData?.userDetails
                                        // const userData = responseData?.userDetails
                                        if (userDetailsFromLocal) {
                                            localStorage.setItem('userData', JSON.stringify(userDetailsFromLocal))
                                        } else {
                                            localStorage.setItem('userData', '{}')
                                        }
                                        dispatch(addEventLog(response, 'PERMIT BOOKING ERROR'))
                                        setPage('thankyou')

                                    } else {

                                        const userData = responseData?.userDetails
                                        if (userData) {
                                            const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                                            userDetailsFromLocal.user = userData
                                            localStorage.setItem('userData', JSON.stringify(userDetailsFromLocal))
                                        } else {
                                            localStorage.setItem('userData', '{}')
                                        }
                                        setResponse(response)
                                        dispatch(addEventLog(response, 'PERMIT BOOKING ERROR'))
                                        setPage('thankyou')
                                    }
                                } else {
                                    if (responseData?.error_msg && responseData?.error_msg != '') {
                                        setResponse(responseData?.error_msg)
                                        setPaymentStatus(false)
                                        const userData = responseData?.userDetails
                                        if (userData) {
                                            localStorage.setItem('userData', JSON.stringify(userData))
                                        } else {
                                            localStorage.setItem('userData', '{}')
                                        }
                                        dispatch(addEventLog(response, 'PERMIT BOOKING ERROR'))

                                        setPage('thankyou')
                                    } else {

                                        const userData = responseData?.userDetails

                                        if (userData) {

                                            localStorage.setItem('userData', JSON.stringify(userData))

                                        } else {
                                            localStorage.setItem('userData', '{}')
                                        }
                                        setPage('thankyou')
                                        dispatch(addEventLog(response, 'PERMIT BOOKING ERROR'))

                                        setResponse(response)
                                    }
                                }

                            } else {
                                setIsLoading(false)
                                closeApplePaySession('failed')
                                const errors = response?.errors
                                setResponse(errors ? errors?.message : 'Something went wrong, Please try again!')
                                //old                  
                                if (errors?.message == 'Invalid password.' || !response?.message || response?.message == '' || response?.message == undefined || response?.message == null) {
                                    setPreviousActive(true)
                                } else {
                                    setPreviousActive(false)
                                }
                                setIsLoading(false)
                                setPaymentStatus(false)
                                dispatch(addEventLog(response, 'PERMIT BOOKING ERROR'))

                                setPage('thankyou')
                            }
                            // formRef.current = false
                        }
                    }).catch((err) => {
                        closeApplePaySession('failed')
                        dispatch(addEventLog(err, 'PERMIT BOOKING ERROR'))
                        setResponse(err ? err : 'Something went wrong, Please try again!')
                        //old                  
                        setIsLoading(false)
                        setPage('thankyou')
                    })
                } else {
                    dispatch(addEventLog('Permit Purchase Flag not received or received other than 0 and 1, went in catch block', 'PERMIT BOOKING ERROR'))
                    setResponse('Something went wrong, Please try again!')
                    setPaymentStatus(false)
                    setIsLoading(false)
                    setPage('thankyou')
                }

                // .catch((error) => { 
                //     formRef.current = false
                //     const ErrorMsg = error?.errors                   
                //     setResponse(ErrorMsg?.message ? ErrorMsg?.message : error)               
                //     setPage('thankyou')
                // })                       

            } else if (formData?.selFaclity?.facility_payment_details?.facility_payment_type_id == '3' && iframeErrorMsg) {
                // EOS-973 Check for iframe errors (when using Fiserv payment gateway)
                notify('error', iframeErrorMsg)
                setIsLoading(false)
                setTermShow(false)
            } else if (terms_condition_error) {
                setIsLoading(false)
                setTermShow(false)
            } else {
                setIsLoading(false)
                setTermShow(false)
            }
        }
    }

    const handlePostSubmission = () => {
        const formData = getVals()
        // isCardFormVisible can be stale from a prior verifyPrepay=='0' render; card fields only actually render when verifyPrepay=='0' || !walletButtonShow (see Pass.js)
        const isCardSectionRendered = isCardFormVisible && (verifyPrepay === '0' || !walletButtonShow)
        let filteredValidatorFieldKeys = excludeKeysFromValidator(validator, isCardSectionRendered, formData, accessPermissions)
        handleSubmit(formData, 'post', false, filteredValidatorFieldKeys)
    }

    return (
        <div>
            {/* loggedInError={loggedInError} */}
            <Header page={page} partnerDetails={partnerDetails} facility={formData?.selFaclity} />
            <main>

                <section id="forms" className="formDesign ">
                    <div className="container mt-2  " id="qbox-container">
                        <div className='row justify-content-center'>
                            <div className="col-lg-10 text-center mb-3">
                                <h1>Permit Request</h1>
                            </div>
                        </div>
                    </div>
                    <Steps
                        page={page}
                    />
                    <div className="container mt-2 " id="qbox-container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                {/* <form className="needs-validation" id="form-wrapper" method="post" action={url} name="form-wrapper"
                                    noValidate=""> */}
                                <form ref={formRef} id='ipg_form' target="_top" name='ipg_form' method='post' onSubmit={() => handleSubmit(formData)}>
                                    <div id="steps-container">
                                        {active == 'home' && <Home
                                            categoryURL={categoryURL} setPage={setPage}
                                            setIdProof={setIdProof} vehicleCount={vehicleCount}
                                            setvehicleCount={setvehicleCount} idProof={idProof}
                                            VehiclePrev={VehiclePrev} vehicleListArray={vehicleListArray}
                                            setVehicleListArray={setVehicleListArray}
                                            formData={formData} setFormData={setFormData}
                                            formError={formError} partnerDetails={partnerDetails}
                                            setMainVehicleMakeList={setMainVehicleMakeList}
                                            setUniversityidProof={setUniversityidProof}
                                            universityidProof={universityidProof} notify={notify}
                                            selectedVehicleList={selectedVehicleList}
                                            setSelectedVehicleList={setSelectedVehicleList}
                                            setDocumentTypes={setDocumentTypes}
                                            documentTypes={documentTypes} setMultiIdProof={setMultiIdProof}
                                            idMultiProof={idMultiProof}
                                            employerDetails={employerDetails}
                                            setEmployerDetails={setEmployerDetails}
                                            validator={validator}
                                            accessPermissions={accessPermissions}
                                            setAccessPermissions={setAccessPermissions}
                                        />}
                                        {active == 'signup' && <SignUp setPage={setPage}
                                            isLoggedIn={isLoggedIn} formData={formData} setFormData={setFormData}
                                            formError={formError} partnerDetails={partnerDetails}
                                            setInvalidCredentialsError={setInvalidCredentialsError} validator={validator}
                                            otp={otp} otpSent={otpSent} otpError={otpError} otpLoading={otpLoading}
                                            otpSentFor={otpSentFor}
                                            resendCooldown={resendCooldown} resendCount={resendCount} maxOtpResend={maxOtpResend}
                                            canResend={canResend} resendLimitReached={resendLimitReached}
                                            handleOtpChange={handleOtpChange} handleResendOtp={handleResendSignupOtp}
                                        />}
                                        {active == 'pass' && <Pass setActive={setActive} active={active}
                                            guidValue={guid} resValue={res} setPage={setPage}
                                            idProof={idProof} formData={formData} setFormData={setFormData}
                                            formError={formError} notify={notify}
                                            selectedVehicleList={selectedVehicleList} setTotalPrice={setTotalPrice}
                                            verifyPrepay={verifyPrepay} walletButtonShow={walletButtonShow} setWalletDisable={setWalletDisable}
                                            employerDetails={makeEmployerPayload(employerDetails)} validator={validator}
                                            isCardFormVisible={isCardFormVisible} setCardFormVisible={setCardFormVisible}
                                            tokenRef={tokenRef} setCardToken={setCardToken} setIframeErrorMsg={setIframeErrorMsg}
                                        />}
                                        {active == 'thankyou' && <ThankYou setPage={setPage} response={response} paymentStatus={paymentStatus} paymentResponse={paymentResponse} isLoading={isLoading} notify={notify} />}
                                        {active == 'thankyouRequest' && <ThankYouRequest setPage={setPage} response={response} paymentStatus={paymentStatus} paymentResponse={paymentResponse} isLoading={isLoading} partnerDetails={partnerDetails} />}

                                    </div>
                                    {errorMessages != '' ? <span className='text-danger'>{errorMessages}</span> : ''}
                                    {(active == 'signup' && invalidCredentials && invalidCredentials != '') ? <div>
                                        <span className='small text-danger d-block'>{invalidCredentials}</span>
                                    </div> : null}
                                    <div id="q-box__buttons" className="text-center mt-4 d-flex justify-content-center">
                                        {(active != 'home' && (previousActive || active == 'signup' || active == 'pass')) &&
                                            <button id="next-btn" type="button" className="btn btn-primary step-btn" onClick={(e) => handlePrevious(e)} disabled={isLoading}>Previous</button>}
                                        &nbsp;
                                        {(active != 'pass' && active != 'thankyou' && active != 'thankyouRequest') &&
                                            <button id="next-btn" type="button" className="btn btn-primary d-flex step-btn" onClick={(e) => handleNext(e)} disabled={isLoading}>{(active == 'signup' && !isLoggedIn && !formData?.otpVerified) ? (otpSent ? 'Verify OTP' : 'Send OTP') : 'Next'} {page == 'signup' && isLoading ? <span className=' ms-2'><Circles
                                                height="20"
                                                width="20"
                                                color="#ffffff"
                                                ariaLabel="circles-loading"
                                                visible={true}
                                            /></span> : null}
                                            </button>}&nbsp;
                                        {(active == 'pass' && (verifyPrepay == '0' || !walletButtonShow)) && <>

                                            {formData?.userConsent ?
                                                <button type="button" disabled={formData?.proRateAPIData?.error_permit_exist && formData?.proRateAPIData?.error_permit_exist != '' ? true : false} onClick={formData?.proRateAPIData?.error_permit_exist && formData?.proRateAPIData?.error_permit_exist != '' ? '' : handleModalTerm} className="btn btn-primary d-flex step-btn" >
                                                    Submit
                                                </button> :

                                                <button id="next-btn" type="button" className="btn btn-primary d-flex step-btn" onClick={() => (formData?.proRateAPIData?.error_permit_exist && formData?.proRateAPIData?.error_permit_exist != '') ? '' : handleSubmit(formData)} disabled={isLoading || (formData?.proRateAPIData?.error_permit_exist && formData?.proRateAPIData?.error_permit_exist != '') ? true : false}>Submit {isLoading ? <span className=' ms-2'><Circles
                                                    height="20"
                                                    width="20"
                                                    color="#ffffff"
                                                    ariaLabel="circles-loading"
                                                    visible={true}
                                                /></span> : null}</button>}</>

                                        }
                                        {(active == 'pass' && verifyPrepay == '1' && walletButtonShow) && <button type="button" disabled={isLoading} className="btn btn-primary d-flex step-btn w-auto" onClick={handlePostSubmission} >
                                            Proceed to Pay
                                        </button>}
                                    </div>
                                    {/* <autoRenewal /> */}
                                    <AutoRenewal setActive={setActive} setPage={setPage} page={page} active={active} formData={formData} setShow={setTermShow} show={showTerm} isLoading={isLoading} handleSubmit={handleSubmit} />

                                </form>
                                {(totalPrice > 0 && active == 'pass' && verifyPrepay == '0' && walletButtonShow && (!formData?.proRateAPIData?.error_permit_exist || formData?.proRateAPIData?.error_permit_exist == '')) ? <>
                                    <div className="my-3 fw-bold text-center">- OR -</div>

                                    <div className='d-flex justify-content-center'>
                                        <div className='position-relative'>
                                            {!(!isPermissionExist(accessPermissions, 'Display Terms & Conditions') || (isPermissionExist(accessPermissions, 'Display Terms & Conditions') && formData?.userAcknowledge)) ? <div className='overlay_terms_cond position-absolute' role='button' onClick={() => handleSubmit(formData, null, true)}>&nbsp;</div> : null}
                                            {(walletDisable || isLoading) ? <div className='overlay-opacity'>&nbsp;</div> : null}
                                            <WalletButtons faciltyData={formData?.selFaclity} getValues={getVals} onSubmit={handleSubmit} isSubmittingForm={isLoading} setIsSubmittingForm={setIsLoading} setIsLoading={setIsLoading} payableAmount={totalPrice} notify={notify} isIOSDevice={isIOSDevice} applePaySessionRef={applePaySessionRef} />
                                        </div>
                                    </div>
                                    <small className='border border-danger p-2 rounded-3 text-center text-small text-danger small w-100'>By using Apple pay/Gpay, the permit can not be auto renewed.</small>
                                    {/* {isIOSDevice ? 
                                        <ApplePayDataCap faciltyData={selectedFacilityData} getValues={getVals} onSubmit={handleSubmit} setIsSubmittingForm={setIsLoading} setIsLoading={setIsLoading} payableAmount={totalPrice} notify={notify}/> :
                                        <GooglePayDC faciltyData={selectedFacilityData} getValues={getVals} onSubmit={handleSubmit} setIsSubmittingForm={setIsLoading} setIsLoading={setIsLoading} payableAmount={totalPrice} notify={notify}/>
                                    } */}
                                </> : ''}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )

}

Main.propTypes = {
    dispatch: PropTypes.func,
    data: PropTypes.object,
    events: PropTypes.object,
    loader: PropTypes.bool,
    getCard: PropTypes.func,
    passData: PropTypes.object,
    isAuthenticated: PropTypes.bool,
    isModeOpen: PropTypes.bool,
    partnerDetails: PropTypes.object,
    notify: PropTypes.func,
    permitPurchageClick: PropTypes.number
}

Main.defaulProps = {
    dispatch: noop,
    data: EMPTY_OBJECT,
    events: EMPTY_OBJECT,
    loader: false,
    getCard: noop,
    passData: EMPTY_ARRAY,
    isAuthenticated: false,
    isModeOpen: false,
    partnerDetails: EMPTY_OBJECT,
    notify: noop,
    permitPurchageClick: 0,
}

function mapStateToProps({ paymentReducer, login, basicInfoReducer }) {
    return {
        data: paymentReducer,
        isAuthenticated: login?.isAuthenticated,
        permitPurchageClick: basicInfoReducer.permitPurchageClick
    }
}
export default connect(mapStateToProps)(Main)
